<!--
 * @Author: TinaHuang0183 
 * @Date: 2022-07-22 11:33:28
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-05-06 17:14:20
 * @FilePath: /notion-widgets-site/src/components/Layouts-v2.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="layout">
    <img class="circle" src="@/assets/home-bg.png" v-show="!show_header" />
    <div class="header" v-if="show_header">
      <div class="site">
        <img id="icon" src="@/assets/icon-1.png" />
        <router-link :to="{ name: 'index' }" :underline="false"
          ><h2>
            {{ site_name }}
          </h2></router-link
        >
        <a href="https://httishere.github.io/widverse-site">
          <el-button
            type="danger"
            size="small"
            round
            data-splitbee-event="To widverse 3.0"
            >前往组件库3.0</el-button
          ></a
        >
        <!-- <el-tag
          ><i class="el-icon-view"></i> <span id="busuanzi_value_site_pv"></span
        ></el-tag>
        <el-tag
          ><i class="el-icon-user"></i> <span id="busuanzi_value_site_uv"></span
        ></el-tag> -->
      </div>
      <div class="extra">
        <router-link
          class="header-link"
          :class="{ active: active_tab === 'plugin' }"
          :to="{ name: 'lib' }"
          >组件</router-link
        >
        <router-link
          class="header-link"
          :class="{ active: active_tab === 'picks' }"
          :to="{ name: 'picks' }"
          >Notion</router-link
        >
        <a
          class="header-link"
          href="https://httishere666.notion.site/b10f03f2226e449887ad86b097e67e78"
          target="_blank"
          >小世界</a
        >
        <a class="header-link" type="info" @click="handleDoc">使用教程</a>
        <a
          class="header-link"
          target="_blank"
          href="https://httishere.notion.site/1bb6ab70c0d646c88459d7e78ff020f4"
          >问题反馈</a
        >
        <router-link
          class="header-link"
          :class="{ active: active_tab === 'releases' }"
          to="/releases"
          >更新日志</router-link
        >
        <!-- <router-link
          class="header-link"
          :class="{
            active: active_tab === '/pro',
            highlight: active_tab === '/pro',
          }"
          :to="{ name: 'pro' }"
          >永久会员</router-link
        > -->
        <router-link :to="{ name: 'pro' }" :underline="false"
          ><el-button type="warning" plain round icon="el-icon-s-opportunity"
            >永久会员</el-button
          ></router-link
        >
        <!-- <router-link
          class="header-link"
          :class="{ active: active_tab === 'reward' }"
          :to="{ name: 'reward' }"
          >赞赏</router-link
        > -->
        <!-- <router-link :to="{ name: 'lib' }" :underline="false"
          ><el-button type="primary" plain round
            >使用组件</el-button
          ></router-link
        > -->
      </div>
    </div>
    <div class="header2" v-else>
      <h1>
        {{ site_name }}
        <!-- <el-button type="danger" size="small" round>前往组件库3.0</el-button> -->
      </h1>
      <div class="menu">
        <!-- <div class="menu-item">首页</div> -->
        <div class="menu-item"><router-link to="/lib">组件</router-link></div>
        <div class="menu-item">
          <router-link to="/picks">模版</router-link>
        </div>
        <div class="menu-item">
          <el-badge value="new" class="item">
            <router-link
              class="header-link"
              :class="{
                active: active_tab === '/pro',
                highlight: active_tab === '/pro',
              }"
              :to="{ name: 'pro' }"
              >永久会员</router-link
            >
          </el-badge>
        </div>
        <div class="menu-item">
          <a
            href="https://httishere666.notion.site/b10f03f2226e449887ad86b097e67e78"
            target="_blank"
            >小世界</a
          >
        </div>
        <div class="menu-item" @click="handleDoc">使用教程</div>
        <!-- <div class="menu-item">
          <router-link to="/reward">为爱发电</router-link>
        </div> -->
        <div class="menu-item">
          <router-link to="/releases">日志</router-link>
        </div>
        <div class="menu-item">
          <router-link to="/news"
            ><div class="menu-item">公告</div></router-link
          >
        </div>
      </div>
    </div>
    <!-- <router-link
      :to="{ name: 'pro' }"
      v-if="pathname !== 'pro' && pathname !== 'create'"
    > -->
    <!-- data-splitbee-event="Be VIP" -->
    <a href="https://httishere.github.io/widverse-site">
      <el-header
        :class="['message-head', show_header ? 'hasHeader' : '']"
        data-splitbee-event="To widverse 3.0"
      >
        👏👏 Widverse · 汪汪汪世界组件库3.0来啦！！
      </el-header>
    </a>
    <!-- </router-link> -->
    <slot></slot>
    <div class="footer">
      <footer-actions />
      <div class="inner">
        <span>© 2022 HTTISHERE 个人所有</span>|<span>
          联系：<a href="mailto:httishere0728@gmail.com" title="邮件"
            >httishere0728@gmail.com</a
          > </span
        >|<span
          >小红书：<a
            target="blank"
            href="https://www.xiaohongshu.com/user/profile/5c049fc9000000000800af53?xhsshare=WeixinSession&appuid=5c049fc9000000000800af53&apptime=1664074455"
            >@肥汪卷</a
          ></span
        >|<span
          >B站：<a
            href="https://space.bilibili.com/19225439?spm_id_from=333.1007.0.0"
            target="blank"
            >@阿汪同学</a
          ></span
        >|<span>微信公众号：<a href="#">汪汪汪世界</a></span>
      </div>
    </div>
    <!-- drawer -->
    <el-drawer
      title="使用教程"
      :visible.sync="drawer"
      :direction="direction"
      size="50%"
    >
      <document />
    </el-drawer>
    <div class="fixed-box">
      <MainComments />
      <!-- qustion -->
      <el-tooltip
        class="question"
        effect="dark"
        content="问题反馈"
        placement="top"
      >
        <a
          class="feedback"
          href="https://httishere.notion.site/1bb6ab70c0d646c88459d7e78ff020f4"
          target="blank"
          >?</a
        >
      </el-tooltip>
    </div>
    <!-- news -->
    <el-dialog
      :title="newUpdate && newUpdate.title"
      :visible.sync="centerDialogVisible"
      width="40%"
      center
    >
      <div class="new-box" v-html="newUpdate && newUpdate.msg"></div>
      <p class="dialog-date">{{ newUpdate && newUpdate.datetime }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleUpdateDialog(newUpdate)">{{
          (newUpdate && newUpdate.btnText) || "立即体验"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Document from "../views/Document.vue";
import FooterActions from "../components/home/FooterActions.vue";
import MainComments from "../components/MainComments.vue";
import { isMobile } from "../utils";
import Lib from "../lib";
export default {
  components: { Document, FooterActions, MainComments },
  data() {
    return {
      site_name: "Widverse · 汪汪汪世界",
      drawer: false,
      direction: "rtl",
      newUpdate: null,
      centerDialogVisible: false,
      // pathname: this.$route.name,
      // news_update:
      is_mobile: isMobile(),
    };
  },
  computed: {
    pathname() {
      console.log("pathname: ", this.$route.name);
      return this.$route.name;
    },
    show_header() {
      let _path = this.$route.name;
      console.log(_path);
      return _path !== "index";
    },
    active_tab() {
      let _path = this.$route.path;
      if (_path.includes("/lib") || _path.includes("/create")) {
        return "plugin";
      } else if (_path.includes("/picks")) {
        return "picks";
      } else if (_path.includes("/releases")) {
        return "releases";
      } else if (_path.includes("/reward")) {
        return "reward";
      }
      return _path;
    },
  },
  mounted() {
    this.getDatas();
    const pathname = this.pathname;
    if (Lib.isPhone() && pathname.substring(0, 1) != "m") {
      console.log("... to mbase");
      this.$router.replace({ name: "mbase" });
    }
  },
  methods: {
    handleDoc() {
      this.drawer = true;
    },

    getDatas() {
      const _this = this;
      this.$axios.get(`./news.json?v=${Math.random()}`).then((res) => {
        let list = res.data.news,
          show_update = localStorage.update;
        for (let i in list) {
          if (list[i].show && list[i].type === "update") {
            _this.newUpdate = list[i];
            break;
          }
        }
        if (!show_update || show_update !== _this.newUpdate.datetime) {
          _this.centerDialogVisible = true;
          localStorage.update = _this.newUpdate.datetime;
        }
      });
    },

    handleUpdateDialog(item) {
      if (item.url) {
        window.location.href = item.url;
      } else if (item.page) {
        this.$router.push(item.page);
        this.centerDialogVisible = false;
      }
      return (this.centerDialogVisible = false);
    },

    handlePlus() {
      console.log("...");
      this.$router.push({ name: "pro" });
    },
  },
};
</script>
<style lang="less" scoped>
@import url(../less/var.less);
.layout {
  position: relative;
  // z-index: 1;
  overflow-x: hidden;

  .circle {
    width: 120vw;
    height: 30vw;
    display: block;
    position: absolute;
    z-index: 0;
    top: -1vw;
    left: -5vw;
    // filter: blur(20px);
  }
}
.header {
  position: fixed;
  left: 0;
  right: 0;
  padding: 15px 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff33;
  backdrop-filter: blur(15px);
  z-index: 1000;
  .site {
    display: flex;
    align-items: center;
    #icon {
      width: 40px;
      height: 40px;
      margin-right: 15px;
    }
    h2 {
      margin: 0;
      font-size: 22px;
    }
    .el-tag {
      margin-left: 10px;
    }
  }
  .header-link {
    margin-right: 20px;
    font-size: 18px;
    padding: 5px 10px;
    cursor: pointer;
    &.active {
      background: @primary-color;
      // border-bottom: 1px solid @primary-color;
      color: #ffffff;
      border-radius: 35px;
    }
    &.highlight {
      background: @focus-color;
    }
  }
}
.header2 {
  color: #ffffff;
  position: relative;
  z-index: 1;
  h1 {
    margin: 0;
    font-size: 48px;
    // width: 5rem;
    padding: 48px;
    text-align: center;
    // border-bottom: 0.1rem double black;
  }
  .menu {
    width: 60vw;
    margin: 0 auto;
    font-size: 30px;
    display: flex;
    justify-content: space-between;
    &-item {
      cursor: pointer;
    }
  }
}
.footer {
  padding: 0 30px;
  text-align: center;
  .inner {
    border-top: 1px solid #f3f3f3;
    padding: 30px;
    font-size: 14px;
    span {
      display: inline-block;
      margin: 0 15px;
    }
  }
}
.fixed-box {
  position: fixed;
  right: 10px;
  bottom: 30px;
  z-index: 1000;
}
.feedback {
  display: block;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  font-size: 24px;
  text-align: center;
  line-height: 48px;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 10%);
  cursor: pointer;
  font-weight: bold;
  float: right;
  margin: 20px;
}
.dialog-date {
  text-align: right;
}
.new-box {
  ::v-deep img {
    max-width: 100%;
    display: block;
  }
  ::v-deep p {
    line-height: 1.5;
    font-size: 15px;
  }
}

.message-head {
  height: 30px !important;
  background-color: #e7e9f9;
  text-align: center;
  line-height: 30px;
  color: #333;
  font-size: 14px;
  cursor: pointer;
  z-index: 1000;
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  &.hasHeader {
    top: 72px;
  }
}
</style>